<template>
  <div class="breadcrumb">
    <div class="row">
      <div class="col-12">
        <ul class="menu">
          <router-link v-for="(route, index) in $route.matched" v-bind:key="index" tag="li" :to="{name:route.name}" v-if="route.meta && Object.keys(route.meta).length > 0">
            <a :class="route.meta.breadcrumbClass">{{$t(route.meta.breadcrumbTitle).capitalize()}}</a>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'Breadcrumb',
    data() {
      return {}
    },
    mounted: function () { }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// shared/layout/Breadcrumb.vue